import React, { useMemo, useState } from "react";
import FormLayoutReader from "../../../components/customFormComponents/editorBlocks/emailBuilder/blocks/EmailLayout/EmailLayoutReader";
import { renderToStaticMarkup } from "react-dom/server";
import classes from './otherForm.module.css';
import { Button } from "antd";
import { shouldComponentBeVisible } from "../../../components/customFormComponents/utils/evaluateCondition";

const OtherForm = props => {

    const {isEmbed, fCode, cmCode, formData, custom_form, handleSubmit, handleAlertError,
        otpLoading,
        canSendOtp,
        waitOtpSeconds,
        validateOtpResult,
        validateOtpLoading,
        handleStartSendOtp,
        handleChangeOTP,
        handleChangeEmail,
        allFieldValues,
        setAllFieldValues,
        formClientWidth,
        setFormClientWidth,
        unSubData,
        errorMessage,
        successMessage,
        languageOptions,
        selectedLanguageCode,
        showLanguageSelector,
        handleChangeLanguage,
        recaptcha
    } = props;

    const [currentPage, setCurrentPage] = useState(0);

    const rootIds = useMemo(() => {
        const ids = Object.keys(formData)?.filter((key) => key.includes('root'));
        let visibleIds = [];
        ids?.forEach(item=>{
            const rootData = formData[item];
            const visibleData = rootData?.data?.props?.visible;
            if(visibleData.alwaysShow) {
                visibleIds.push(item);
            }
            else {
                const checkVisible = shouldComponentBeVisible(visibleData?.conditions, allFieldValues);
                if(checkVisible) {
                    visibleIds.push(item);
                }
            }
        })
        return visibleIds;
    }, [formData, allFieldValues])

    const totalPage = useMemo(() => {
        return rootIds.length;
    }, [rootIds])

    const formView = useMemo(()=>{
        if(rootIds?.length > currentPage && formData[rootIds[currentPage]]) {
            const currentRootId = rootIds[currentPage];
            return <>
                <FormLayoutReader
                    isEmbed={isEmbed}
                    fCode={fCode}
                    cmCode={cmCode}
                    props={formData[currentRootId]?.data}
                    custom_form={custom_form}
                    handleSubmit={handleSubmit}
                    formData={formData}
                    handleAlertError={handleAlertError}
                    otpLoading={otpLoading}
                    canSendOtp={canSendOtp}
                    waitOtpSeconds={waitOtpSeconds}
                    validateOtpResult={validateOtpResult}
                    validateOtpLoading={validateOtpLoading}
                    handleStartSendOtp={handleStartSendOtp}
                    handleChangeOTP={handleChangeOTP}
                    handleChangeEmail={handleChangeEmail}
                    allFieldValues={allFieldValues}
                    setAllFieldValues={setAllFieldValues}
                    formClientWidth={formClientWidth}
                    setFormClientWidth={setFormClientWidth}
                    unSubData={unSubData}
                    errorMessage={errorMessage}
                    successMessage={successMessage}
                    languageOptions={languageOptions}
                    selectedLanguageCode={selectedLanguageCode}
                    showLanguageSelector={showLanguageSelector}
                    handleChangeLanguage={handleChangeLanguage}
                    recaptcha={recaptcha}
                />
            </>
        }
        else {
            return <p style={{
                textAlign: 'center',
                padding: '24px 32px'
            }}>Empty Form</p>
        };
    }, [isEmbed, allFieldValues, canSendOtp, custom_form, formData, rootIds, currentPage, handleAlertError, handleChangeEmail, 
        handleChangeOTP, handleStartSendOtp, handleSubmit, otpLoading, setAllFieldValues, 
        validateOtpLoading, validateOtpResult, waitOtpSeconds, setFormClientWidth, formClientWidth, unSubData,
        errorMessage, successMessage, cmCode, fCode, handleChangeLanguage, languageOptions, selectedLanguageCode, showLanguageSelector,
        recaptcha
    ])

    return !totalPage || totalPage === 1 ? formView : <div className={classes.root} style={{
        paddingBottom: isEmbed ? `${90+(formData[rootIds[currentPage]]?.data?.padding?.bottom || 32)}px` : '0' 
    }}>
        {formView}
        <div className={classes.paginationSection} style={{
            position: isEmbed ? 'absolute' : 'fixed'
        }}>
            <div className={classes.pagination}>
                <div>
                    <Button style={{
                        display: currentPage === 0 ? 'none' : 'block'
                    }}
                        onClick={() => {
                            setCurrentPage(prev => Math.max(prev - 1, 0));
                        }}
                    >
                        Previous
                    </Button>
                </div>
                <span className={classes.pageInfo}>
                    {currentPage + 1} / {totalPage}
                </span>
                <div>
                    <Button type="primary" style={{
                        display: currentPage === totalPage - 1 ? 'none' : 'block'
                    }}
                        onClick={() => {
                            custom_form.validateFields().then(values => {
                                // 所有字段校验通过后的操作
                                setCurrentPage(prev => Math.min(prev + 1, totalPage - 1));
                            }).catch(errors => {
                                // 存在校验不通过的字段
                            })
                            
                        }}
                    >
                        Next
                    </Button>
                </div>
            </div>
        </div>
    </div>
}

export default OtherForm;
